import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import KontentItemCtaButton from "./kontentItemCtaButton";
import Eyecatcher from "../components/eyecatcher/eyecatcher";

const KontentItemEyecatcher = ({ data }) => {
  const eyecatcher = data.value ? data.value[0] : data;

  if (!eyecatcher || !eyecatcher.elements) {
    return null;
  }

  return (
    <Eyecatcher
      title={eyecatcher.elements.title.value}
      text={eyecatcher.elements.text.value}
    >
      {eyecatcher.elements.buttons.value.map(
        (button) => (<KontentItemCtaButton data={button} key={`ctabutton${button.id}`} />),
      )}
    </Eyecatcher>
  );
};

export const query = graphql`
  fragment KontentItemEyecatcher on kontent_item_eyecatcher {
    id
    system {
      codename
    }
    elements {
      title {
        value
      }
      text {
        value
      }
      buttons {
        value {
          ...KontentItemCtaButton
        }
      }
    }
  }
`;

KontentItemEyecatcher.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemEyecatcher;
